import { render } from "./PreviewPanel.vue?vue&type=template&id=2ae561e4&scoped=true&ts=true"
import script from "./PreviewPanel.vue?vue&type=script&lang=ts"
export * from "./PreviewPanel.vue?vue&type=script&lang=ts"

import "./PreviewPanel.vue?vue&type=style&index=0&id=2ae561e4&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae561e4"]])

export default __exports__